import { BookIconComponent } from '@plugins/client/icons/book-icon/book-icon.component';
import { CalendarTodayIconComponent } from '@plugins/client/icons/calendar-today-icon/calendar-today-icon.component';
import { ComputerIconComponent } from '@plugins/client/icons/computer-icon/computer-icon.component';
import { DateRangeIconComponent } from '@plugins/client/icons/date-range-icon/date-range-icon.component';
import { MapIconComponent } from '@plugins/client/icons/map-icon/map-icon.component';
import { SchoolIconComponent } from '@plugins/client/icons/school-icon/school-icon.component';
import { VideocamIconComponent } from '@plugins/client/icons/videocam-icon/videocam-icon.component';
import { LearningObjectTypeEnum } from '@plugins/octacornerstone-lib/enums';

import { TrainingTypeProps } from '../models/training-type-props.interface';

const learningObjectTypesMap: Record<
  LearningObjectTypeEnum,
  TrainingTypeProps
> = {
  [LearningObjectTypeEnum.CURRICULUM]: {
    icon: SchoolIconComponent,
    label: 'type.curriculum',
  },
  [LearningObjectTypeEnum.MATERIAL]: {
    icon: BookIconComponent,
    label: 'type.material',
  },
  [LearningObjectTypeEnum.VIDEO]: {
    icon: VideocamIconComponent,
    label: 'type.video',
  },
  [LearningObjectTypeEnum.EXTERNAL_TRAINING]: {
    icon: MapIconComponent,
    label: 'type.external-training',
  },
  [LearningObjectTypeEnum.ONLINE_COURSE]: {
    icon: ComputerIconComponent,
    label: 'type.online-course',
  },
  [LearningObjectTypeEnum.EVENT]: {
    icon: CalendarTodayIconComponent,
    label: 'type.event',
  },
  [LearningObjectTypeEnum.SESSION]: {
    icon: DateRangeIconComponent,
    label: 'type.session',
  },
};

export const getLearningObjectType = (key: string): TrainingTypeProps =>
  (learningObjectTypesMap[key] as TrainingTypeProps) ?? {
    icon: null,
    label: null,
    typeKey: key,
  };
